<section id="category-description-box-top">
  <h1 class="text-3xl font-bold text-grey-0 md:text-4xl">
    {{ title() }}
  </h1>

  @if (!searchDescription().introduction && name() && pluralName() && place()) {
    <div
      class="mt-4 text-base text-grey-0">
      <p
        (scrollDownClicked)="scrollDownClick()"
        [seeMoreForceShow]="true"
        appSeeMoreScroll
      >
        På varden.se kan du jämföra <span class="bold">{{ count() + ' ' }}</span>
        {{ count() | i18nPlural : {'=1': name(), other: pluralName()} | lowercase }}
        i {{ place() }}. Boka tid på den mottagning som passar dina behov bäst.<span></span>
      </p>
    </div>
  }

  @if (searchDescription().introduction) {
    <div
      (scrollDownClicked)="scrollDownClick()"
      [elementCssClass]="'font-bold'"
      [innerHTML]="searchDescription().introduction"
      [seeMoreScrollContent]="searchDescription().introduction"
      appSeeMoreScroll
      class="mt-4 text-base text-grey-0"
    ></div>
  }
</section>
